<div class="card mt-2 mb-1">

    <div class="d-block card-header pb-0 pt-1">
        <div class="btn-group float-right mt-2" role="group">
            <button type="button" class="btn btn-primary btn-sm btn-icon" [ngClass]="{ 'btn-icon-on': actionFilter === actionsCV.SHORT_INSERT }" title="{{'entity.worklog.action.I' | translate}}" (click)="filterAction(actionsCV.SHORT_INSERT)">
                <i class="fas fa-plus-square"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm btn-icon" [ngClass]="{ 'btn-icon-on': actionFilter === actionsCV.SHORT_UPDATE }" title="{{'entity.worklog.action.U' | translate}}" (click)="filterAction(actionsCV.SHORT_UPDATE)">
                <i class="fas fa-edit"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm btn-icon" [ngClass]="{ 'btn-icon-on': actionFilter === actionsCV.SHORT_ADD_EXPIRE }" title="{{'entity.worklog.action.AV' | translate}}" (click)="filterAction(actionsCV.SHORT_ADD_EXPIRE)">
                <i class="far fa-calendar-times"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm btn-icon" [ngClass]="{ 'btn-icon-on': actionFilter === actionsCV.SHORT_REMOVE_EXPIRE }" title="{{'entity.worklog.action.XV' | translate}}" (click)="filterAction(actionsCV.SHORT_REMOVE_EXPIRE)">
                <i class="far fa-calendar-check"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm btn-icon" [ngClass]="{ 'btn-icon-on': actionFilter === actionsCV.DEACTIVATE }" title="{{'entity.worklog.action.X' | translate}}" (click)="filterAction(actionsCV.SHORT_DEACTIVATE)">
                <i class="fas fa-toggle-off"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm btn-icon" [ngClass]="{ 'btn-icon-on': actionFilter === actionsCV.SHORT_ACTIVATE }" title="{{'entity.worklog.action.A' | translate}}" (click)="filterAction(actionsCV.SHORT_ACTIVATE)">
                <i class="fas fa-toggle-on"></i>
            </button>
            <button type="button" class="btn btn-primary btn-sm btn-icon" [ngClass]="{ 'btn-icon-on': !actionFilter }" title="{{'common.all.male' | translate}}" (click)="filterAction()">
                {{'common.all.male' | translate}}
            </button>
        </div>            
        <div class="form-group mx-sm-3 mb-2 float-right mt-2">
            <input 
                autocomplete="off" 
                #searchTableInput 
                appTableInputSearch 
                tableId="worklogTable" 
                name="searchTableInput" 
                type="text" 
                class="form-control" 
                id="searchTableInput" 
                placeholder="{{'common.find' | translate}} ( Ctrl + f )"/>
        </div>
        <div *ngIf="isNewAllowed()" class="btn-group float-right mt-2" role="group">
            <button type="button" class="btn btn-primary btn-sm btn-icon" 
                title="{{'common.new' | translate}}" 
                (click)="newComment()">
                <i class="fas fa-plus"></i>
            </button>
        </div>
    </div>
    <div class="tab-content h-85" id="myTabContent">
        <table 
            appTable 
            id="worklogTable" 
            delete="false"
            edit="false"
            [appTableOptions]="appTableOptions"
            class="table table-bordered table-hover w-100">
            <thead>
            <tr>
                <th>Id</th>
                <th>{{'entity.worklog.item.action' | translate}}</th>
                <th>{{'entity.worklog.item.updateDateTime' | translate}}</th>
                <th>{{'entity.worklog.item.updateUserName' | translate}}</th>
                <th>{{'entity.worklog.item.comment' | translate}}</th>
            </tr>
            </thead>
            <tbody>
            </tbody>
        </table>
    </div>
</div>

